<template>
    <div class="vx-card p-6 ">
        <vs-tabs>
            <vs-tab label="Trạng thái">
                <SettingStatus></SettingStatus>
            </vs-tab>
            <vs-tab label="Nhãn công việc">
                <SettingLabel></SettingLabel>
            </vs-tab>
            <vs-tab label="Cấp độ ưu tiên">
                <SettingPriority></SettingPriority>
            </vs-tab>
        </vs-tabs>
    </div>
</template>
<script>
import SettingStatus from "./SettingStatus.vue"
import SettingLabel from "./SettingLabel.vue";
import SettingPriority from "./SettingPriority.vue";

export default {
    components: {
        SettingStatus,
        SettingLabel,
        SettingPriority
    },}
</script>
